import { Autocomplete, Chip, TextField } from "@mui/material";
import { useMemo } from "react";

const mergeOptions = (options, extra) => {
  const map = new Map();
  [...(options || []), ...(extra || [])].forEach((o) => {
    if (o && o.id != null && !map.has(o.id)) map.set(o.id, o);
  });
  return Array.from(map.values());
};

/**
 * انتخاب چندتایی شهرهای تحت پوشش امور برق.
 * value: آرایه شناسه شهرها، options/selectedItems: آیتم‌های { id, title }.
 */
const AreaCitiesAutocomplete = ({
  options,
  selectedItems,
  value,
  onChange,
  disabled,
  loading,
  helperText = "اگر یک شهر زیر پوشش چند امور باشد (مثل مناطق یک کلان‌شهر)، هنگام ارجاع انتخاب امور الزامی است.",
}) => {
  const allOptions = useMemo(
    () => mergeOptions(options, selectedItems),
    [options, selectedItems]
  );
  const selected = useMemo(() => {
    const ids = new Set((value || []).map(Number));
    return allOptions.filter((o) => ids.has(Number(o.id)));
  }, [allOptions, value]);

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={allOptions}
      value={selected}
      loading={loading}
      disabled={disabled}
      getOptionLabel={(o) => o?.title || ""}
      isOptionEqualToValue={(o, v) => Number(o.id) === Number(v.id)}
      onChange={(_, items) => onChange(items.map((i) => Number(i.id)))}
      renderTags={(items, getTagProps) =>
        items.map((item, index) => (
          <Chip
            {...getTagProps({ index })}
            key={item.id}
            size="small"
            label={item.title}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="شهرهای تحت پوشش"
          placeholder="جستجوی شهر"
          helperText={helperText}
        />
      )}
      noOptionsText="شهری یافت نشد"
    />
  );
};

export default AreaCitiesAutocomplete;
